import { DistributionsUsageDetails } from '@features/usage/components/distributions/DistributionsUsageDetails'
import {
  CheckPermissionsWrapper,
  Operations,
  Permission,
} from '@lib/permissions'
import { createFileRoute } from '@tanstack/react-router'

const usageDistributionReadPermission = new Permission(
  ['usage', 'distribution'],
  Operations.Read
)

const DistributionsRoute = () => (
  <CheckPermissionsWrapper permissions={[usageDistributionReadPermission]}>
    <DistributionsUsageDetails />
  </CheckPermissionsWrapper>
)

export const Route = createFileRoute('/_auth/o/$orgId/usage/distributions')({
  component: DistributionsRoute,
})
